/* eslint-disable no-unused-vars */
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';

import PersistLogin from './PersistLogin';
import ProtectRoute from 'auth/ProtectRoute';

import HomePage from 'page/home';

import SignIn from 'page/sign-in';
import SignUp from 'page/sign-up';
import SignOut from 'page/signout';
import Unauthorized from 'page/unauthorized';
import Notfound from 'page/notfound';
import Dashboard from 'page/dashboard';

import SearchPolicy from 'page/searchPolicy';

import Cart from 'page/cart';
import Orders from 'page/orders';
import Order from 'page/order';
import OrderPayment from 'page/orderPayment';

import NLCode from 'page/insurance-nlcode';
import NLExt from 'page/insurance-nlcode-ext';

import InsuranceForm from 'page/insurance-form';

import AdminUsers from 'page/admin-users/AdminUsers';
import AdminUser from 'page/admin-user';
import AdminReport from 'page/admin-report';

import AdminOrder from 'page/admin-order';

import Rapid from 'page/insurance-rapid-form';
import RapidPayment from 'page/rapid-payment';
import RapidOrder from 'page/rapid-order';

import MaintenanceLine from 'page/maintenanceLine';
import RapidNLCode from 'page/insurance-rapid-nlcode';
import RapidALcode from 'page/insurance-rapid-nlcode-ext';
import Mou from 'page/mou';
import ROLES from 'auth/roles';
import ResetPwd from 'page/resetPwd';

const InsuranceExcel = lazy(() => import('page/insurance-excel'));

const AppRoutes = () => {
  if (Number(process.env.REACT_APP_MAINTENANCE_MODE)) {
    return (
      <Routes>
        <Route path="*" element={<MaintenanceLine />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/forgot_password" element={<ResetPwd />} />
      <Route path="/" element={<HomePage />} />
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/sign-up" element={<SignUp />} />
      <Route path="/sign-up/:code" element={<SignUp />} />
      <Route path="/sign-out" element={<SignOut />} />

      <Route path="/rapid" element={<Rapid />} />
      <Route path="/rapid/payment/:invoiceId" element={<RapidPayment />} />
      <Route path="/rapid/order/:invoiceId" element={<RapidOrder />} />

      <Route path="/rapid_ewp" element={<RapidNLCode />} />

      <Route path="/rapid_al_ext" element={<RapidALcode />} />

      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/notfound" element={<Notfound />} />

      <Route element={<PersistLogin />}>
        <Route element={<ProtectRoute allowedRoles={[ROLES.User]} />}>
          <Route path="/dashboards" element={<Dashboard />} />
          <Route path="/search" element={<SearchPolicy />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/order" element={<Orders />} />
          <Route path="/order/payment/:invoiceId" element={<OrderPayment />} />
          <Route path="/order/:invoiceId" element={<Order />} />
          <Route path="/policy-mou" element={<Mou />} />
          <Route path="/policy-mou/form" element={<InsuranceForm />} />
          <Route
            path="/policy-mou/excel"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <InsuranceExcel />
              </Suspense>
            }
          />

          <Route path="/policy-ewp" element={<NLCode />} />
          <Route path="/policy-ewp-ext" element={<NLExt />} />

          <Route element={<ProtectRoute allowedRoles={[ROLES.Admin]} />}>
            <Route path="/admin/user" element={<AdminUsers />} />
            <Route path="/admin/user/:id" element={<AdminUser />} />
            <Route path="/admin/report" element={<AdminReport />} />

            <Route path="/admin/order/:invoiceId" element={<AdminOrder />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<Notfound />} />
    </Routes>
  );
};

export default AppRoutes;
